import Base from "./base";
const StudentExamService = {
    ...Base
};

export default StudentExamService;